import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import Homepage from './components/Homepage';
import PricingPage from './components/PricingPage';
import CompareZendesk from './components/CompareZendesk';
import CompareFreshdesk from './components/CompareFreshdesk';
import CompareEmail from './components/CompareEmail';
import InviteAcceptance from './components/auth/InviteAcceptance';
import OAuthSuccessPage from './components/auth/OAuthSuccessPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import DataDeletion from './components/DataDeletion';
import reportWebVitals from './reportWebVitals';
import EmailVerificationSuccess from './components/auth/EmailVerificationSuccess';
import api from './services/api';
import ForEcommerce from './components/pages/ForEcommerce';
import ForSaaS from './components/pages/ForSaaS';
import ForAgencies from './components/pages/ForAgencies';
import PricingComparison from './components/pages/PricingComparison';
import Blog from './components/pages/Blog';
import ZendeskAlternatives from './components/pages/ZendeskAlternatives';
import CustomerSupportMultipleChannels from './components/pages/CustomerSupportMultipleChannels';
import RespondNegativeReviews from './components/pages/RespondNegativeReviews';
import FAQ from './components/pages/FAQ';
import DocsHome from './components/docs/DocsHome';
import QuickStart from './components/docs/QuickStart';
import GmailSetup from './components/docs/GmailSetup';

const root = ReactDOM.createRoot(document.getElementById('root'));

function AppWrapper() {
  const handleLoginSuccess = (userData) => {
    // User is logged in, redirect to app
    window.location.href = '/app';
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/app/*" element={<App />} />
        <Route path="/login" element={<App />} />
        <Route path="/register" element={<App />} />
        <Route path="/pricing" element={<PricingPage />} />

        {/* Comparison Pages */}
        <Route path="/compare/zendesk" element={<CompareZendesk />} />
        <Route path="/compare/freshdesk" element={<CompareFreshdesk />} />
        <Route path="/compare/email" element={<CompareEmail />} />

        {/* Landing Pages */}
        <Route path="/for-ecommerce" element={<ForEcommerce />} />
        <Route path="/for-saas" element={<ForSaaS />} />
        <Route path="/for-agencies" element={<ForAgencies />} />
        <Route path="/pricing-comparison" element={<PricingComparison />} />

        {/* Blog Pages */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/zendesk-alternatives-small-business" element={<ZendeskAlternatives />} />
        <Route path="/blog/customer-support-multiple-channels" element={<CustomerSupportMultipleChannels />} />
        <Route path="/blog/respond-negative-reviews-fast" element={<RespondNegativeReviews />} />

        {/* FAQ Page */}
        <Route path="/faq" element={<FAQ />} />

        {/* Documentation Pages */}
        <Route path="/docs" element={<DocsHome />} />
        <Route path="/docs/quick-start" element={<QuickStart />} />
        <Route path="/docs/gmail-setup" element={<GmailSetup />} />
        {/* Add more documentation routes here as you create them */}

        {/* Legal Pages */}
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/data-deletion" element={<DataDeletion />} />

        <Route path="/invite/:token" element={<InviteAcceptance />} />

        {/* OAuth Success Route - Fixed */}
        <Route
          path="/oauth-success"
          element={
            <OAuthSuccessPage
              onLoginSuccess={handleLoginSuccess}
              api={api}
            />
          }
        />

        {/* Email Verification Route */}
        <Route
          path="/verify-email/:token"
          element={
            <EmailVerificationSuccess
              api={api}
              onLoginSuccess={handleLoginSuccess}
            />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

root.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>
);

reportWebVitals();